<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
    <main class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 class="fw-bold mb-0">Admin KYC Applications</h4>
      <div class="text-muted small">Review and process verification applications</div>
    </div>

    <button class="btn btn-outline-secondary btn-sm" (click)="load()">
      Refresh
    </button>
  </div>

  <div class="card shadow-sm border-0 mb-4">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-2">
          <label class="form-label small">Status</label>
          <select class="form-select" [(ngModel)]="filter.status">
            <option value="">All</option>
            <option value="Draft">Draft</option>
            <option value="PendingSubmission">PendingSubmission</option>
            <option value="Submitted">Submitted</option>
            <option value="UnderReview">UnderReview</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
            <option value="Expired">Expired</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small">Country</label>
          <input class="form-control" [(ngModel)]="filter.jurisdictionCode" placeholder="NG" />
        </div>

        <div class="col-md-2">
          <label class="form-label small">Tier</label>
          <input class="form-control" [(ngModel)]="filter.tierCode" placeholder="BASIC" />
        </div>

        <div class="col-md-2">
          <label class="form-label small">Customer Type</label>
          <select class="form-select" [(ngModel)]="filter.customerType">
            <option value="">All</option>
            <option value="Individual">Individual</option>
            <option value="Business">Business</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small">Product Type</label>
          <select class="form-select" [(ngModel)]="filter.productType">
            <option value="">All</option>
            <option value="Wallet">Wallet</option>
            <option value="Trading">Trading</option>
            <option value="Remittance">Remittance</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small">Search</label>
          <input class="form-control" [(ngModel)]="filter.search" placeholder="Name or email" />
        </div>
      </div>

      <div class="mt-3 d-flex gap-2">
        <button class="btn btn-primary btn-sm" (click)="load()">Apply</button>
        <button class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">Reset</button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="!loading && !items.length" class="alert alert-light border">
    No KYC applications found.
  </div>

  <div *ngIf="items.length" class="card shadow-sm border-0">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>User</th>
            <th>Country</th>
            <th>Tier</th>
            <th>Product</th>
            <th>Status</th>
            <th>Submitted</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of items">
            <td>
              <div class="fw-semibold">{{ item.fullName }}</div>
              <div class="small text-muted">{{ item.email }}</div>
              <div class="small text-muted" *ngIf="item.phone">{{ item.phone }}</div>
            </td>

            <td>{{ item.jurisdictionCode }}</td>
            <td>{{ item.tierCode }}</td>
            <td>{{ item.productType }}</td>

            <td>
              <span class="badge" [ngClass]="getStatusClass(item.status)">
                {{ item.status }}
              </span>
            </td>

            <td>{{ item.submittedAt || item.startedAt | date:'medium' }}</td>

            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary" (click)="open(item)">
                Open
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

<app-footer></app-footer>
    </main>
    </div>